"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AboutPopup = AboutPopup;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Flex_1 = __importDefault(require("../Layout/Flex"));
const Primitives_1 = require("../Primitives");
const Text_1 = require("../Text");
const Copy_1 = require("../Icons/Copy");
const styled_components_1 = __importDefault(require("../styled-components"));
const __1 = require("../");
const narwhal_1 = require("@centralwebteam/narwhal");
const StyledTable = styled_components_1.default.table `
  border: none;
  border-spacing: 10px;
`;
const LegalNotices = styled_components_1.default.a `
  color: ${(props) => props.theme.link};
  &:visited {
    color: ${(props) => props.theme.link};
  }
`;
function AboutPopup({ header, versionInfo, buildInfo, emptyMessage, onPopupClose, open, isHelios, referenceElement, }) {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    const tplDirectory = isHelios ? ".." : ".";
    let versionFilteredInfo = {
        coreInstallVersion: versionInfo.coreInstallVersion,
        coreLicensed: versionInfo.coreLicensed,
        coreLicenceType: versionInfo.coreLicenseType,
        ipcLicensed: versionInfo.ipcLicensed,
        daysRemaining: versionInfo.daysRemaining,
        connectionLimit: versionInfo.connectionLimit,
        apiVersion: versionInfo.apiVersion,
        webAppVersion: versionInfo.webAppVersion,
        commsType: versionInfo.communicationType,
        provisioningId: versionInfo.provisioningId,
        apiUrl: versionInfo.apiUrl,
    };
    if (buildInfo !== undefined)
        versionFilteredInfo = {
            ...versionFilteredInfo,
            webAppVersion: cleanBuildInfo(buildInfo === null || buildInfo === void 0 ? void 0 : buildInfo.buildnumber),
        };
    return (react_1.default.createElement(__1.Popup, { open: open, onClose: onPopupClose, referenceElement: referenceElement, title: header, primaryActions: react_1.default.createElement(Primitives_1.Button, { title: t("button-Close"), onClick: onPopupClose }, t("button-Close")), secondaryActions: react_1.default.createElement(Primitives_1.Button, { autoFocus: true, title: t("button-Copy to clipboard"), onClick: () => {
                const txt = createClipboardText(versionFilteredInfo);
                narwhal_1.clipboard.writeText(txt);
            } },
            react_1.default.createElement(Copy_1.Copy, null),
            react_1.default.createElement("div", { style: { padding: 4 } }),
            t("button-CopyDetails")) },
        react_1.default.createElement(Flex_1.default, { padding: "0 0 20px" }, Object.keys(versionFilteredInfo).length > 1 &&
            versionFilteredInfo.constructor === Object ? (react_1.default.createElement(Flex_1.default, { align: "center", justify: "center", noGrow: true },
            react_1.default.createElement(Flex_1.default, { align: "flex-start", noGrow: true },
                react_1.default.createElement(Flex_1.default, { noGrow: true, col: true },
                    react_1.default.createElement(StyledTable, null,
                        react_1.default.createElement("tbody", null,
                            Object.entries(versionFilteredInfo).map((d) => {
                                return (react_1.default.createElement("tr", { key: d[0] },
                                    react_1.default.createElement("td", { style: { alignContent: "baseline" } },
                                        react_1.default.createElement(Text_1.Text, { style: {
                                                textTransform: "capitalize",
                                            } }, 
                                        // @ts-ignore
                                        t(`label-${d[0]}`))),
                                    react_1.default.createElement("td", null,
                                        react_1.default.createElement(Text_1.Text, { wrapLines: true, key: d[0], testId: "label-" + d[0], style: {
                                                opacity: 0.5,
                                                fontStyle: d[1] === t("label-SignInToView")
                                                    ? "italic"
                                                    : "normal",
                                            } }, d[1]))));
                            }),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(Text_1.Text, { style: {
                                            textTransform: "capitalize",
                                        } }, t("heading-Third Party Licences"))),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(Flex_1.default, { col: true },
                                        react_1.default.createElement(Text_1.Text, null,
                                            react_1.default.createElement(LegalNotices, { href: `${tplDirectory}/ThirdPartyLicenses/ThirdPartyLicenses_backend.rtf`, target: "_blank", "data-testid": "link-api" }, t("link-API")),
                                            "\u00A0",
                                            react_1.default.createElement(LegalNotices, { href: "ThirdPartyLicenses.rtf", target: "_blank", "data-testid": "link-webApp" }, t("link-Web App")))))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", { colSpan: 2 },
                                    react_1.default.createElement(Flex_1.default, null,
                                        react_1.default.createElement(LegalNotices, { href: "MSA_central.rtf", target: "_blank", "data-testid": "link-eula" }, t("link-EULA")),
                                        react_1.default.createElement(LegalNotices, { href: "notices.txt", target: "_blank", style: { paddingLeft: "10px" }, "data-testid": "link-legalNotices" }, t("link-Legal Notices"))))),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(Text_1.Text, { style: {
                                            textTransform: "capitalize",
                                        } }, t("label-Copyright")))))))))) : (react_1.default.createElement(Flex_1.default, { align: "center", justify: "flex-start", noGrow: true }, emptyMessage)))));
    function createClipboardText(obj) {
        let totalText = "";
        Object.entries(obj).forEach((entry) => {
            const [key, value] = entry;
            totalText +=
                t(`label-${key}`, { defaultValue: key }) + ": " + value + "\n";
        });
        totalText += t("label-URL") + ": " + window.location.href;
        return totalText;
    }
    function cleanBuildInfo(buildInfo) {
        // Expected format
        // centralwebteam manatee pull request_xx.xxx.xx
        if (buildInfo) {
            const str = buildInfo.split("_");
            if (str.length === 2) {
                return str[1];
            }
            return buildInfo;
        }
        return t("label-Unknown");
    }
}
//# sourceMappingURL=index.js.map